import 'moment/locale/es';

import RootNavigator from 'navigation';

function App() {
  return <RootNavigator />;
}

export default App;
